// Data Transfer Objects for Enterprise operations
// Enterprise Report Type Model
export class EnterpriseReportType {
  constructor(data = {}) {
    this.id = data.id || null;
    this.enterpriseId = data.enterpriseId || null;
    this.name = data.name || '';
    this.customEnterpriseInstructions = data.customEnterpriseInstructions || '';
    this.description = data.description || '';
    this.examplesCount = data.examplesCount || 15;
    this.enterpriseExampleProportion = data.enterpriseExampleProportion !== undefined ? data.enterpriseExampleProportion : 0.75;
    this.isFavorite = data.isFavorite !== undefined ? data.isFavorite : true;
    this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
    this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : null;
  }
}


export class CreateEnterpriseReportTypeDTO {
  constructor(data = {}) {
    this.name = data.name || '';
    this.systemPrompt = data.systemPrompt || '';
    this.customEnterpriseInstructions = data.customEnterpriseInstructions || '';
    this.description = data.description || '';
    this.examplesCount = data.examplesCount || 15;
    this.enterpriseExampleProportion = data.enterpriseExampleProportion !== undefined ? data.enterpriseExampleProportion : 0.75;
    this.model = data.model || 'gpt-4.1';
    this.temperature = data.temperature || 0.2;
    this.maxTokens = data.maxTokens || 4000;
    this.isJson = data.isJson || false;
    this.specialty = data.specialty || null;
  }
}

export class UpdateEnterpriseReportTypeDTO {
  constructor(data = {}) {
    // Only include fields that are being updated
    if (data.name !== undefined) this.name = data.name;
    if (data.systemPrompt !== undefined) this.systemPrompt = data.systemPrompt;
    if (data.customEnterpriseInstructions !== undefined) this.customEnterpriseInstructions = data.customEnterpriseInstructions;
    if (data.description !== undefined) this.description = data.description;
    if (data.examplesCount !== undefined) this.examplesCount = data.examplesCount;
    if (data.enterpriseExampleProportion !== undefined) this.enterpriseExampleProportion = data.enterpriseExampleProportion;
    if (data.model !== undefined) this.model = data.model;
    if (data.temperature !== undefined) this.temperature = data.temperature;
    if (data.maxTokens !== undefined) this.maxTokens = data.maxTokens;
    if (data.isJson !== undefined) this.isJson = data.isJson;
    if (data.isFavorite !== undefined) this.isFavorite = data.isFavorite;
    if (data.specialty !== undefined) this.specialty = data.specialty;
  }
}

export class CreateEnterpriseExampleDTO {
  constructor(data = {}) {
    this.reportType = data.reportType || '';
    this.correctedContent = data.correctedContent || '';
    // Only include transcription if it's provided
    if (data.transcription) {
      this.transcription = data.transcription;
    }
    // Include annex if provided (optional)
    if (data.annex) {
      this.annex = data.annex;
    }
  }
}

export class UpdateEnterpriseExampleDTO {
  constructor(data = {}) {
    // Only include fields that are being updated
    if (data.transcription !== undefined) this.transcription = data.transcription;
    if (data.correctedContent !== undefined) this.correctedContent = data.correctedContent;
  }
}

export class CreateEnterpriseDTO {
  constructor(data = {}) {
    this.name = data.name || '';
    this.shortName = data.shortName || '';
    this.description = data.description || '';
    this.settings = data.settings || {};
    this.maxLicenses = data.maxLicenses || 5;
    this.specialty = data.specialty || null;
  }
}

export class UpdateEnterpriseDTO {
  constructor(data = {}) {
    // Only include fields that are being updated
    if (data.name !== undefined) this.name = data.name;
    if (data.shortName !== undefined) this.shortName = data.shortName;
    if (data.description !== undefined) this.description = data.description;
    if (data.isFavorite !== undefined) this.isFavorite = data.isFavorite;
    if (data.settings !== undefined) this.settings = data.settings;
    if (data.maxLicenses !== undefined) this.maxLicenses = data.maxLicenses;
    if (data.specialty !== undefined) this.specialty = data.specialty;
  }
}